import { getAuth, sendEmailVerification } from 'firebase/auth'
import { useEffect, useState } from 'react'
import Loading from 'react-loading'
import Lottie from 'react-lottie'
import { useDispatch, useSelector } from 'react-redux'
import signout from '../../api/auth/signout'
import * as animationData from '../../assets/animations/email-load-animation.json'
import * as verifedAnimation from '../../assets/animations/verified.json'
import useBreakpoints from '../../hooks/useBreakpoints'
import { selectUserPropsState, userSliceActions } from '../../store/features/user'
import { LogoLight } from '../atoms/Logo'
import LogoSm from '../atoms/LogoSm'

const first_animationOptions = {
  animationData: animationData,
  loop: true,
  autoPlay: false,
  rendererSettings:{
      preserveAspectRatio: 'xMidYMid slice'
  } 
}

const second_animationOptions = {
  animationData: verifedAnimation,
  loop: false,
  autoPlay: true,
  rendererSettings:{
      preserveAspectRatio: 'xMidYMid slice'
  } 
}

export default function UnverifiedAdmin() {

  const [isSigningOut, setIsSigningOut] = useState(false)
  const [verificationState, setVerificationState] = useState("loading")
  const breakPoint = useBreakpoints()
  const userPropState = useSelector(selectUserPropsState)
  const dispatch = useDispatch()

  
  useEffect(()=>{

    if(userPropState?.emailVerified){
      setVerificationState("verified")
      return
    }
    
    const timeOut = resendVerificationMessage()
    
    const interval = setInterval(async()=>{
      
      const currentUser = getAuth().currentUser

      if(currentUser){
        await currentUser.reload()
        if(currentUser.emailVerified){
            clearTimeout(timeOut)
            dispatch(userSliceActions.setUserProps({
              ...userPropState,
              emailVerified: true
            }))
        }

      }

      
    }, 500)
    
    

    return ()=>{
      // clearTimeout(timeOut)
      clearInterval(interval)
    }

  //eslint-disable-next-line     
  }, [])


  const resendVerificationMessage : ()=>NodeJS.Timeout = ()=>{

    let timeOut: NodeJS.Timeout;
    
    try {

      setVerificationState("loading")

      timeOut = setTimeout(()=>{
        setVerificationState("failed")
      }, 60000)

      sendEmailVerification(getAuth().currentUser!)
      
    } catch (error) {
        console.log(error);
    }

    return timeOut!
    
  }


  const handleBtnSignoutOnClick = async()=>{

    try {

      setIsSigningOut(true)

      await signout()
      
    } catch (error) {
      console.log(error);
      setIsSigningOut(false)
    }
    
  }
  
  
  return (
    <div className='w-full h-full bg-primary_darker text-gray-400 flex flex-col duration-300 transition'>

      {/* navbar */}
      <nav className="w-full p-4 bg-primary_lighter flex justify-between items-center">

          {
            breakPoint === "xs" ? (
              <div className="w-8 h-8">
                <LogoSm />
              </div>
            ) :(
              <LogoLight />
            )
          }
          <div 
            className="py-2 px-4 bg-primary rounded text-secondary2 border border-gray-400/60 cursor-pointer hover:bg-primary_darker text-center"
            role="button"
            onClick={handleBtnSignoutOnClick}
          >
              {
                isSigningOut ? (
                  <Loading 
                    type='spin'
                    width={16}
                    height={16}
                    className="text-secondary2"
                  />
                ):(
                  <span>Sign out</span>
                )
              }
          </div>
        
      </nav>
      <main className="w-full flex-auto flex justify-center items-center">

          <div
            className='w-2/5 h-3/5 bg-primary rounded border border-gray-400/60 flex-col flex justify-center items-center relative p-8 text-center sm:w-11/12 md:w-9/12'
          >

            <h3 className="text-secondary2 font-semibold text-2xl">
              Verify your email address
            </h3>

            <p className="text-center text-sm inline-block w-3/5 my-4 xs:w-11/12">
              We sent a verification link to the email address you provided during registration.
              Please follow it to let us know it belongs to you.
            </p>

            {
              verificationState==="loading" && (
                <Lottie 
                    options={first_animationOptions}
                    width={breakPoint === "xs" ? 58 : 72}
                    height={breakPoint === "xs" ? 58 : 72}
                />
              ) 
            }
            {
              (verificationState==="verified" && userPropState?.emailVerified) && (
                <Lottie 
                    options={second_animationOptions}
                    width={breakPoint === "xs" ? 58 : 72}
                    height={breakPoint === "xs" ? 58 : 72}
                    eventListeners={[
                      {
                        eventName: "complete",
                        callback: ()=>{},
                      }
                    ]}
                />
              ) 
            }
            {
              verificationState==="failed" &&(
                <button 
                  className="bg-secondary rounded text-primary py-2 px-4"
                  onClick={resendVerificationMessage}
                >
                      Resend verification email
                  </button>
              )
            }

            {/* <div className="absolute top-0 right-0 w-1/5 h-1/5 pattern1_bg opacity-40" /> */}

          </div>
          
      </main>
      
    </div>
  )
}
